import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { OverlayGetter, OverlayState } from "@/components/overlay/types";

export const getters: GetterTree<OverlayState, RootState> &
  Record<OverlayGetter, Getter<OverlayState, RootState>> = {
  [OverlayGetter.GetOverlayOpen](state) {
    return state.OverlayOpen;
  },
  [OverlayGetter.GetChannelEpg](state) {
    return state.channelEpg;
  },
  [OverlayGetter.GetActiveEpgItem](state) {
    return state.activeEpgItem;
  },
  [OverlayGetter.GetActiveVodItem](state) {
    return state.activeVodItem;
  },
  [OverlayGetter.GetActiveVodItemDuration](state) {
    return state.activeVodItemDuration;
  },
  [OverlayGetter.GetActiveVodItemProgressDuration](state) {
    return state.activeVodItemProgressDuration;
  },
  [OverlayGetter.GetTvShowMeta](state) {
    return state.tvShowMeta;
  }
};
